import {
  DateFormats,
} from "@/scripts/Common/DateFormats";

import moment from "moment";
export class HelperFunctions {

  private static deciamlCountRegEx = /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/

  public static GetDecimalsCount(value: string) {
    const match = value.match(this.deciamlCountRegEx);
    if (!match) {
      return 0;
    }
    return Math.max(
      0,
      (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
    );
  }

  public static IsEndDateAfterStartDate(startDate: string, endDate: string) {
    return new Date(endDate).getTime() > new Date(startDate).getTime()
  }

  public static IsEndDateAfterOrEqualToStartDate(startDate: string, endDate: string) {
    return new Date(endDate).getTime() >= new Date(startDate).getTime()
  }

  public static IsEmailValid(email: string) {
    const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return emailPattern.test(email);
  }

  public static CopyText(text: string) {
    navigator.clipboard.writeText(text).catch((_) => {
    });
  }

  public static isEmpty(str: string | undefined) {
    return (!str || str.length === 0);
  }

  // Laden des letzten Tages des Monats über angabe der 0 wird dieser automatisch geholt.
  public static getLastDayOfMonth(year: number, month: number): number {
    return new Date(year, month, 0).getDate()
  }
}

const copyObject = (value: any) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (_) {
    return undefined;
  }
}

const debounce = (fn: Function, ms = 500) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

const getMinDateRestriction = moment().add(1, 'days').format(DateFormats.ISO8601_LONG);

const isEmpty = (value: string | undefined) => (!value || value.length === 0);

function isAbortError(error: any): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}

interface PlainObject {
  hasOwnProperty<K extends string>(key: K): this is Record<K, unknown>

  // Object.hasOwn() is intended as a replacement for Object.hasOwnProperty(). See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn
  hasOwn<K extends string>(key: K): this is Record<K, unknown>
}

function isPlainObject(value: unknown): value is PlainObject {
  return !!value && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)
}


export {
  copyObject,
  isEmpty,
  debounce,
  getMinDateRestriction,
  isPlainObject,
  isAbortError
}
